// @flow

import middleware from 'app/common/redux/middleware';
import reducers from 'app/www-unauth/redux/reducers';
import type { ClientContext } from 'app/common/lib/context';
import type { ExperimentsClientsMap } from 'app/common/lib/buildExperimentsClients';
import type { State } from 'app/www-unauth/redux/types';
import type { Store } from 'redux';
import { compose, createStore } from 'redux';

const devtools =
  typeof window === 'object' &&
  typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined' &&
  process.env.NODE_ENV !== 'production'
    ? window.__REDUX_DEVTOOLS_EXTENSION__()
    : (f) => f;

export default function configureStore(
  initialContext: ClientContext,
  initialState?: State,
  experimentsClient?: ExperimentsClientsMap,
  // $FlowFixMe: New error after Flow Upgrade http://pinch.pinadmin.com/flow53upgdoc
): Store {
  const state = initialState || {
    location: {
      history: [{ pathname: initialContext.visible_url }],
      pathname: initialContext.visible_url,
    },
  };

  const store = createStore(
    reducers(),
    state,
    compose(
      middleware(),
      devtools,
    ),
  );

  // $FlowFixMe: New error after Flow Upgrade http://pinch.pinadmin.com/flow53upgdoc
  store.dynamicReducers = {};
  return store;
}
